import { ConnectDropTarget, useDrop } from "react-dnd";
import { EDragDropObject } from "../EDragDropObject";

export function useDropTarget<TDraggedObject>(
    identifiers: EDragDropObject[],
    dropHandler: (draggedObject: TDraggedObject) => void,
    hoverHandler?: (draggedObject: TDraggedObject) => void
): IDropTargetResult<TDraggedObject> {
    const accept = identifiers.map((identifier) => EDragDropObject[identifier]);

    const useDropResult = useDrop(() => ({
        accept,
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            isDragging: monitor.canDrop(),
            draggedObject: monitor.getItem<TDraggedObject>(),
            canDrop: monitor.canDrop(),
        }),
        drop: dropHandler,
        hover: hoverHandler,
    }));

    const result: IDropTargetResult<TDraggedObject> = {
        isOver: useDropResult[0].isOver,
        isDragging: useDropResult[0].isDragging,
        draggedObject: useDropResult[0].draggedObject,
        dropTargetRef: useDropResult[1],
        canDrop: useDropResult[0].canDrop,
    };

    return result;
}

export interface IDropTargetResult<TDraggedObject> {
    isOver: boolean;
    isDragging: boolean;
    draggedObject: TDraggedObject;
    dropTargetRef: ConnectDropTarget;
    canDrop: boolean;
}
